import { haversineDistance, interpolateLatLng } from "./locationUtils";

/**
 * Function to calculate the current position of the pig
 * 
 * @category Utils 
 */
export function findCurrentPigPosition(points, currentTime) {
  //This gets the latest passTime
  const speedPoint = points.reduce((latest, current) => {
    if (!current.PassTime || !current.Approved) {
      // Return the latest found so far if current doesn't have a PassTime
      return latest;
    }

    // Convert current PassTime to timestamp for comparison
    const currentTime = new Date(current.PassTime).getTime();

    // If there's no latest (i.e., this is the first valid PassTime we're encountering), use current
    if (!latest) {
      return current;
    }

    // Convert the latest's PassTime to a timestamp for comparison
    const latestTime = new Date(latest.PassTime).getTime();

    // Update latest if the current entry's PassTime is newer
    return currentTime > latestTime ? current : latest;
  }, null); // Initialize with null to ensure the first valid PassTime can replace it

  if (!speedPoint) {
    return null; // Return null if no valid latest point is found
  }

  // console.log(speedPoint)

  const passTime = new Date(speedPoint.PassTime).getTime(); // Convert passTime to milliseconds

  const elapsedTime = (currentTime - passTime) / 1000; // Time in seconds since passTime

  const speedInMetersPerSecond = speedPoint.Speed * 1000 / 3600;
  let distanceTraveled = speedInMetersPerSecond * elapsedTime;

  if(distanceTraveled < 0) return null;

  let accumulatedDistance = 0;
  let lastPoint = speedPoint;
  for (let i = points.indexOf(speedPoint) + 1; i < points.length; i++) {

    const nextPoint = points[i];
    
    const segmentDistance = haversineDistance(lastPoint.lat, lastPoint.lng, nextPoint.lat, nextPoint.lng) * 1000; // Assuming you have a function to calculate distances

    /*************************************** */
    /**This is using the elongation values */
    //Using the elongation values we can adjust the distances so the pig moves correctly with Real Chain values 
    //when using calculated values to determine distance in Haversine
    //code added 12-12-2024 - Bryan Lilly
    
    let adjustedSegmentDistance;
    if(nextPoint.Elong_Percent){
      adjustedSegmentDistance = segmentDistance * (1 + nextPoint.Elong_Percent / 100);
    } else {
      adjustedSegmentDistance = segmentDistance;
    }
    

    accumulatedDistance += adjustedSegmentDistance;

    if (accumulatedDistance >= distanceTraveled) {
      const excess = accumulatedDistance - distanceTraveled;
      const fraction = (adjustedSegmentDistance - excess) / adjustedSegmentDistance;

      let position = interpolateLatLng(lastPoint, nextPoint, fraction);


      const travelTime = adjustedSegmentDistance / speedInMetersPerSecond * 1000; // Total time to travel this segment in seconds
      const numSteps = travelTime / 100; // Number of steps for this segment
      const stepNumber = Math.round(fraction * numSteps);
      
      return { 
        position, 
        stepIndex: i - 1, 
        stepNumber, 
        numSteps, 
        speed: speedPoint.Speed, 
        totalDist: accumulatedDistance, 
        lastPoint, 
        nextPoint 
      }
    }


    /******************************************* */

    //below code was commented/removed 12-12-2024 
    //replace by above snippet 


    // accumulatedDistance += segmentDistance;

    // if (accumulatedDistance >= distanceTraveled) {
    //   const excess = accumulatedDistance - distanceTraveled;
    //   const fraction = (segmentDistance - excess) / segmentDistance;

    //   let position = interpolateLatLng(lastPoint, nextPoint, fraction);


    //   const travelTime = segmentDistance / speedInMetersPerSecond * 1000; // Total time to travel this segment in seconds
    //   const numSteps = travelTime / 100; // Number of steps for this segment
    //   const stepNumber = Math.round(fraction * numSteps);

    //   return { position, stepIndex: i - 1, stepNumber, numSteps, speed: speedPoint.Speed, totalDist: accumulatedDistance }
    // }
    lastPoint = nextPoint;
  }

  // return lastPoint; // If the loop completes, the marker is at or beyond the last point
  // Return the last point in a structured way similar to when position is calculated
  return {
    position: { lat: lastPoint.lat, lng: lastPoint.lng },
    stepIndex: points.length - 1,
    stepNumber: 0, // No more steps to take as it's the last point
    numSteps: 0,
    speed: 0, // Speed is zero as it should no longer move
    totalDist: accumulatedDistance,
    lastPoint, 
  };
}


/**
 * 
 * @category Utils 
 */
export function rotateIcon(url, rotationAngle, callback) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const image = new Image();

  image.onload = () => {
    // Calculate the diagonal to ensure the canvas is large enough
    const diagonal = Math.sqrt(image.width * image.width + image.height * image.height);
    canvas.width = canvas.height = diagonal; // Set canvas size to the diagonal

    ctx.translate(diagonal / 2, diagonal / 2); // Move to the center of the canvas
    //ctx.scale(1, -1); // Flip the image vertically
    ctx.rotate((rotationAngle * Math.PI) / 180); // Rotate the canvas

    // Draw the image centered on the canvas
    ctx.drawImage(image, -image.width / 2, -image.height / 2);

    callback(canvas.toDataURL());
  };

  image.src = url;
}